import { message } from "antd";
import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

export interface CancelWalletRefundItem {
  po_item_id: number;
  quantity: number;
}

export const cancelAndWalletRefund = async (payload: {
  po_items: CancelWalletRefundItem[];
  reason: string;
}) => {
  try {
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}/cancel-and-wallet-refund/`,
        payload
      )
      .then((res) => {
        message.success("PO cancelled and wallet credited successfully");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Failed to cancel and refund. Please try again.");
        return null;
      });
  } catch (error) {
    message.error("Failed to cancel and refund. Please try again.");
    return null;
  }
};

export const getPOVendorDashboardData = async (params: any) => {
  try {
    console.log(params);
    const emptyFilteredParams = Object.keys(params).reduce((acc, key) => {
      if (params[key] !== "") {
        acc[key] = params[key];
      }
      return acc;
    }, {} as Record<string, string>);

    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-vendor-dashboard/`, {
        params: { ...emptyFilteredParams },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error getting PO Vendor Dashboard data. Please try again."
        );
        return;
      });
  } catch (e) {
    message.error("Error getting PO Vendor Dashboard data. Please try again.");
    return null;
  }
};

export const getPOMarginData = async (params: any) => {
  try {
    const emptyFilteredParams = Object.keys(params).reduce((acc, key) => {
      if (params[key] !== "") {
        acc[key] = params[key];
      }
      return acc;
    }, {} as Record<string, string>);
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-margin-dashboard/`, {
        params: { ...emptyFilteredParams },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO Margin data. Please try again.");
        return;
      });
  } catch (e) {
    message.error("Error getting PO Margin data. Please try again.");
    return null;
  }
};

export const getPOLog = async (params: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-log/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO Log data. Please try again.");
        return;
      });
  } catch (e) {
    message.error("Error getting PO Log data. Please try again.");
    return null;
  }
};

export const createPurchaseOrder = async (value: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/po/`, value)
      .then((res) => {
        message.success("PO created succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const createPurchaseOrderV2 = async (value: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/po/`, value)
      .then((res) => {
        message.success("PO created succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const editPurchaseOrder = async (
  po_id: any,
  params: any,
  qParams = {}
) => {
  try {
    return axios
      .put(`${process.env.REACT_APP_API_URL}/po/` + po_id + "/", params, {
        params: { ...qParams },
      })
      .then((res) => {
        message.success("PO edited succesfully");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error editing PO. Please try again.");
        return false;
      });
  } catch (error) {
    message.error("Error in editing PO.");
    return false;
  }
};

export const getPurchaseOrders = async (params: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO. Please try again.");
        return;
      });
  } catch (error) {}
};
export const getPurchaseOrdersoptimzed = async (params: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-optimzed/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO. Please try again.");
        return;
      });
  } catch (error) {}
};

export const getPurchaseOrderDetails = async (po_id: string) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po/` + po_id)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO details. Please try again.");
        return;
      });
  } catch (error) {
    return null;
  }
};

export const resendPOEmail = async (po_id: string) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/po-email-resend/?po_id=` +
          po_id
      )
      .then((res) => {
        message.success("Mail sent.");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting PO details. Please try again.");
        return;
      });
  } catch (error) {
    return null;
  }
};

export const cancelPurchaseOrder = async (
  po_id: string | undefined,
  formData: FormData
) => {
  try {
    return axios
      .put(`${process.env.REACT_APP_API_URL}/po/${po_id}/`, formData)
      .then((res) => {
        message.success("Successfully cancelled PO!");
        window.history.back();
      })
      .catch(() => {
        message.error("Something went wrong!");
      });
  } catch (error) {
    return null;
  }
};

export const restorePurchaseOrder = async (po_id: string | undefined) => {
  try {
    const formData = new FormData();
    formData.append("is_deleted", "false");
    return axios
      .put(`${process.env.REACT_APP_API_URL}/po/${po_id}/`, formData)
      .then((res) => {
        message.success("PO restored successfully!");
        return res?.data;
      })
      .catch(() => {
        message.error("Something went wrong!");
        return null;
      });
  } catch (error) {
    message.error("Something went wrong!");
    return null;
  }
};

export const addInvoiceToPo = async (value: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/po-invoice/`, value)
      .then((res) => {
        message.success("Invoice added succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const removeInvoiceFromPo = async (id: any) => {
  try {
    return axios
      .delete(`${process.env.REACT_APP_API_URL}/po-invoice/` + id + "/")
      .then((res) => {
        message.success("Invoice removed succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error removing invoice. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const getPOInvoices = async (po_id: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-invoice/?po=` + po_id)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const exportPOCSV = async (params: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-export-csv/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error exporting PO data. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error exporting PO data. Please try again.");
    return null;
  }
};

export const pushPOInvoiceToZoho = async (
  po_id: any,
  estimate_id: any,
  stratos = false
) => {
  try {
    message.loading({ content: "Pushing PO to Zoho", key: "pushPOToZoho" });
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/zoho-invoice/?po_id=` +
          po_id +
          "&estimate_id=" +
          estimate_id +
          (stratos ? "&raise_to_stratos=true" : "")
      )
      .then((res) => {
        // message.success("PO pushed to Zoho succesfully");
        message.success({
          content: "PO pushed to Zoho succesfully",
          key: "pushPOToZoho",
        });
        return res?.data;
      })
      .catch((error) => {
        // errorActions(error, "Error pushing PO to Zoho. Please try again.");
        const errorData = error?.response?.data;
        const errorMessage = errorData?.message ?? "";
        message.error({
          content: `Error pushing PO to Zoho. Please try again. ${errorMessage}`,
          key: "pushPOToZoho",
        });
        return;
      });
  } catch (error) {
    message.error("Error pushing PO to Zoho. Please try again.");
    return null;
  }
};

export const pushPOPurchaseOrderToZoho = async (
  po_id: any,
  entity = "haut-luxe"
) => {
  try {
    message.loading({
      content: "Pushing PO to Zoho",
      key: "pushPOInvoiceToZoho",
    });
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/zoho-purchase-order/?po_id=` +
          po_id +
          "&entity=" +
          entity
      )
      .then((res) => {
        // message.success("PO pushed to Zoho succesfully");
        message.success({
          content: "PO pushed to Zoho succesfully",
          key: "pushPOInvoiceToZoho",
        });
        return res?.data;
      })
      .catch((error) => {
        // errorActions(error, "Error pushing PO to Zoho. Please try again.");
        message.error({
          content: "Error pushing PO to Zoho. Please try again.",
          key: "pushPOInvoiceToZoho",
        });
        return;
      });
  } catch (error) {
    message.error("Error pushing PO to Zoho. Please try again.");
    return null;
  }
};

export const createLoginextOrders = async (
  start_date?: string,
  end_date?: string
) => {
  try {
    message.loading({
      content: "Creating orders in LogiNext",
      key: "createLoginextOrders",
    });

    return axios
      .get(`${process.env.REACT_APP_API_URL}/create-loginext-orders/`, {
        params: { start_date, end_date },
      })
      .then((res) => {
        message.success({
          content: "Pushed POs to LogiNext successfully",
          key: "createLoginextOrders",
        });
        return res?.data;
      });
  } catch (error) {
    message.error({
      content: "Error creating orders. Please try again.",
      key: "createLoginextOrders",
    });
    return null;
  }
};

export const createLoginextOrder = async ({
  po_number,
  depot,
  dispatch_date,
}: {
  po_number: string;
  depot?: string;
  dispatch_date?: string;
}) => {
  try {
    message.loading({
      content: "Creating order in LogiNext",
      key: "createLoginextOrder",
    });

    return axios
      .post(`${process.env.REACT_APP_API_URL}/create-loginext-order/`, {
        po_number,
        depot,
        dispatch_date,
      })
      .then((res) => {
        message.success({
          content: "Pushed PO to LogiNext successfully",
          key: "createLoginextOrder",
        });
        return res?.data;
      });
  } catch (error) {
    message.error({
      content: "Error creating order. Please try again.",
      key: "createLoginextOrder",
    });
    return null;
  }
};

export const getLoginextTrips = async (params: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/loginext-trip/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const createPidgeOrder = async (po_id: number) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/push-to-pidge/`, {
        params: {
          po_id: po_id,
        },
      })
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const getLoginextOrderETAs = async (dispatch_date: string) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/loginext-order-eta/`, {
        params: { dispatch_date },
      })
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const getPOLogByLoginextTrip = async (params: Record<string, any>) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/po-log-by-trip/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const assigneVehicleNumberToTrip = async ({
  trip_name,
  vehicle_number,
}: {
  trip_name: string;
  vehicle_number: string;
}) => {
  try {
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}/assign-vehicle-number-to-trip/`,
        {
          trip_name,
          vehicle_number,
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const createReverseFlowRequest = async (payload: any) => {
  try {
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}/return-exchange-po-create/`,
        payload
      )
      .then((res) => {
        message.success("Reverse flow request created successfully");
        return res?.data;
      });
  } catch (error) {
    message.error("Error creating reverse flow request. Please try again.");
    return null;
  }
};

// /apiV1/po-item-reverse-raised-for/
export const getReverseFlowRequestedPOItems = async (params: any) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/po-item-reverse-raised-for/`,
        {
          params: { ...params },
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

// zoho-export-invoice-pdf/
export const getInvoiceRaisedFor = async ({
  estimate_id,
  po_id,
}: {
  estimate_id?: number;
  po_id?: number;
}) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/zoho-export-invoice-pdf/`, {
        params: { estimate_id, po_id },
      })
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

export const downloadTaxInvoice = async ({
  estimate_id,
  po_id,
}: {
  estimate_id?: number;
  po_id?: number;
}) => {
  try {
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}/zoho-export-invoice-pdf/`,
        {},
        {
          params: { estimate_id, po_id },
          responseType: "blob",
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

// apiV1/attach-document-to-po/
export const attachDocumentToPO = async (payload: {
  attachment_url: string;
  po_id: number;
  attachment_type: string;
}) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/attach-document-to-po/`, {
        ...payload,
      })
      .then((res) => {
        message.success("Document attached successfully");
        return res?.data;
      });
  } catch (error) {
    message.error("Error attaching document. Please try again.");
    return null;
  }
};

export const getRefundsWithDetails = async (params: any) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/refund-with-details/`, {
      params: { ...params },
    })
    .then((res) => {
      return res?.data;
    })
    .catch((error) => {
      errorActions(error, "Error getting refunds. Please try again.");
      return;
    });
};

export const decideRefundsWithDetails = async (params: any) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/refund-with-details/`, {
      ...params,
    })
    .then((res) => {
      return res?.data;
    })
    .catch((error) => {
      errorActions(error, "Error getting refunds. Please try again.");
      return;
    });
};

export const getRefundTransactions = async (refundId: any) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/rzp-refund-transaction/`, {
      params: { refund_id: refundId },
    })
    .then((res) => {
      return res?.data || [];
    })
    .catch((error) => {
      errorActions(
        error,
        "Error getting refund transactions. Please try again."
      );
      return;
    });
};

export const getRefundTransactionLogs = async (transactionId: any) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/refund-transaction-log/`, {
      params: { refund_transaction_id: transactionId },
    })
    .then((res) => {
      return res?.data || [];
    })
    .catch((error) => {
      errorActions(
        error,
        "Error getting refund transaction logs. Please try again."
      );
      return;
    });
};

// All logs for every transaction of a refund in one call (avoids a per-transaction fetch).
export const getRefundTransactionLogsByRefund = async (refundId: any) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/refund-transaction-log/`, {
      params: { refund_transaction__refund: refundId },
    })
    .then((res) => {
      return res?.data || [];
    })
    .catch((error) => {
      errorActions(
        error,
        "Error getting refund transaction logs. Please try again."
      );
      return [];
    });
};
// /apiV1/check-refund-is-manual/
export const checkRefundIsManual = async (refundId: any) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/check-refund-is-manual/`, {
      params: { refund_id: refundId },
    })
    .then((res) => {
      return res?.data || null;
    })
    .catch((error) => {
      errorActions(
        error,
        "Error checking if refund is manual. Please try again."
      );
      return;
    });
};

export const getDeliveryDateTime = async (po_no: string) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/edit-delivery-date/`, {
        params: { po_no },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting delivery datetime. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error getting delivery datetime. Please try again.");
    return null;
  }
};

export const updateDeliveryDateTime = async (payload: {
  po_no: string;
  delivery_datetime: string;
  delivery_remark: string;
}) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/edit-delivery-date/`, payload)
      .then((res) => {
        message.success("Delivery datetime updated successfully");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error updating delivery datetime. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error updating delivery datetime. Please try again.");
    return null;
  }
};

// ============================================================================
// Delhivery booking — a PO's local (same-city) delivery via Delhivery, mirroring the
// Porter/LogiNext booking flow. Every call is keyed by po_number. Because the UI branches
// on HTTP status (400 = ineligible, 409 = already booked, 404 = no booking), these return a
// normalized { ok, status, data, error } instead of throwing, so the page can read the code
// and the body (a 409 quote/book still carries the existing order_id + tracking_url).
// ============================================================================
export interface DelhiveryResult<T = any> {
  ok: boolean;
  status: number;
  data: T | null;
  error?: string; // human reason pulled from the error body (detail/message/error)
}

const delhiveryError = (error: any): string | undefined => {
  const body = error?.response?.data;
  if (!body) return undefined;
  if (typeof body === "string") return body;
  return body.detail || body.message || body.error || undefined;
};

// Step 1 — preview / eligibility. 200 → { vehicle_mode, fare, ... }; 400 → ineligible (reason in
// error); 409 → already booked (data carries existing order_id + tracking_url).
export const delhiveryQuote = async (
  po_number: string
): Promise<DelhiveryResult> => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-quote/`,
      { po_number }
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// Step 2 — book. The single click; re-validates + re-quotes server-side. 200 → booking payload
// (order_id, vehicle_mode, fare, tracking_url, ...); 409 → already booked (safe on double-click).
// vehicle_mode is the mode the user picked from the quote's vehicle list (omit to let the backend
// fall back to its priority-1 default). pickup/drop contact numbers come from the quote, editable
// before booking — sent through so the rider's pickup/drop contacts reflect any override.
export const delhiveryBookOrder = async (
  po_number: string,
  opts: {
    vehicle_mode?: string;
    pickup_contact_number?: string;
    drop_contact_number?: string;
    pickup_otp_enabled?: boolean;
    drop_otp_enabled?: boolean;
  } = {}
): Promise<DelhiveryResult> => {
  try {
    const payload: Record<string, any> = { po_number };
    if (opts.vehicle_mode) payload.vehicle_mode = opts.vehicle_mode;
    if (opts.pickup_contact_number)
      payload.pickup_contact_number = opts.pickup_contact_number;
    if (opts.drop_contact_number)
      payload.drop_contact_number = opts.drop_contact_number;
    // Per-handover OTP flags — each always sent as a real boolean (default false). Delhivery sends
    // the code to that end's contact phone; the rider collects it. (Replaces the old otp_enabled.)
    payload.pickup_otp_enabled = opts.pickup_otp_enabled === true;
    payload.drop_otp_enabled = opts.drop_otp_enabled === true;
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-book-order/`,
      payload
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// Step 3 — live status. Merges our DB state with Delhivery's Track API. 404 → no Delhivery booking
// on this PO.
export const delhiveryOrderStatus = async (
  po_number: string
): Promise<DelhiveryResult> => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/delhivery-order-status/`,
      { params: { po_number } }
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// The exact reasons Delhivery accepts for a cancel — render as a dropdown, send verbatim.
export const DELHIVERY_CANCEL_REASONS = [
  "taking too long to assign a driver",
  "service is no longer required",
  "requested wrong vehicle",
  "requested wrong pickup or destination",
  "pickup tat breached",
  "fraudulent rider behaviour",
] as const;

// Step 4 (optional) — cancel. After a 200 the PO is bookable again (step 1 succeeds afresh).
export const delhiveryCancelOrder = async (
  po_number: string,
  reason: string
): Promise<DelhiveryResult> => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-cancel-order/`,
      { po_number, reason }
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// ============================================================================
// Delhivery bookings list — the dashboard feed (GET /delhivery-bookings/). Pure DB, no Delhivery
// calls, so it's fast/pollable; drill into a row with delhivery-order-status/ for live tracking.
// Includes deleted/revised rows (flagged) so bookings hijacked by the legacy Porter conversion stay
// visible. All filters optional and combinable.
// ============================================================================
export interface DelhiveryBookingRow {
  po_number: string;
  lead_id: string | null; // enquiry/lead id — shown in the "Lead ID" column, links to the OMS order
  oms_sales_order_id: number | null; // click-through target → /oms/:id
  vendor_name: string | null;
  po_created_at: string | null;
  order_id: string | null; // CRN...
  status: string | null; // last_updated_status (fulfilment)
  leg_status: string | null;
  vehicle_number: string | null;
  requested_vehicle: string | null; // vehicle type requested at booking — shown under the vehicle number
  delivery_person_name: string | null;
  delivery_person_contact: string | null; // rider phone — shown in the "Rider contact" column
  pickup_contact: string | null; // pickup POC phone sent on booking — shown in Additional details
  drop_contact: string | null; // drop POC phone sent on booking — shown in Additional details
  pickup_time: string | null;
  delivery_time: string | null;
  tracking_url: string | null;
  booked_at: string | null;
  booked_by: string | null; // who booked it — shown in the "Booked by" column
  origin_label: string | null; // origin — top of the clickable "Route" column
  origin_lat: number | null; // precise pin for the origin maps link (falls back to a text search)
  origin_long: number | null;
  destination_label: string | null; // destination — bottom of the clickable "Route" column
  destination_lat: number | null; // precise pin for the destination maps link
  destination_long: number | null;
  cargo_weight_kg?: number | null; // computed cargo — shown greyed under the PO number
  cargo_max_length_ft?: number | null; // longest item — shown greyed under the PO number
  // The line items on this booking — shown in a scrollable "Items" cell (can be many).
  cargo_items?: Array<{
    allocation_item_id: number;
    name: string;
    quantity: number;
    unit: string | null;
  }>;
  is_cancellable?: boolean; // backend says this booking can still be cancelled → show Cancel button
  is_deleted?: boolean;
  is_revised?: boolean;
  // Multistop trip flags. A multistop trip is one CRN (order_id) shared by several PO rows.
  booking_id?: number | null;
  consolidated_with?: string[] | null; // other POs on the same CRN
  is_multistop_delhivery_booked?: boolean; // true → this PO rides a multistop trip (>1 pickup)
}

export interface DelhiveryBookingsResponse {
  count: number;
  limit: number;
  offset: number;
  results: DelhiveryBookingRow[];
}

export interface DelhiveryBookingsFilters {
  po_number?: string;
  order_id?: string;
  booked_from?: string; // booked_at range, YYYY-MM-DD
  booked_to?: string; // booked_at range, YYYY-MM-DD
  status?: string | string[]; // a list is sent as repeated status= params (Django getlist)
  leg_status?: string;
  limit?: number;
  offset?: number;
}

export const getDelhiveryBookings = async (
  filters: DelhiveryBookingsFilters = {}
): Promise<DelhiveryBookingsResponse | undefined> => {
  try {
    // Drop empty/undefined filters so we never send e.g. status= (which the backend would reject).
    const params = Object.entries(filters).reduce((acc, [k, v]) => {
      if (v === "" || v === undefined || v === null) return acc;
      if (Array.isArray(v) && v.length === 0) return acc;
      acc[k] = v;
      return acc;
    }, {} as Record<string, any>);
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/delhivery-bookings/`,
      {
        params,
        // A list-valued filter (status) is sent as repeated params — status=a&status=b — the Django
        // `getlist` convention, not the bracketed status[]=… axios would emit by default.
        paramsSerializer: (p: Record<string, any>) => {
          const usp = new URLSearchParams();
          Object.entries(p).forEach(([k, v]) => {
            if (Array.isArray(v)) v.forEach((item) => usp.append(k, String(item)));
            else usp.append(k, String(v));
          });
          return usp.toString();
        },
      }
    );
    return res?.data as DelhiveryBookingsResponse;
  } catch (error: any) {
    errorActions(error, "Error loading Delhivery bookings. Please try again.");
    return undefined;
  }
};

// One carrier Track per active booking, catching our stored status up to Delhivery when a webhook
// didn't land. Slow (seconds to ~1 min) — long client timeout; safe to re-run (settled bookings skip).
export interface DelhiveryReconcileTransition {
  order_id: string;
  booking_id: number;
  to: string; // new status
  at: string; // ISO timestamp of the transition
}
export interface DelhiveryReconcileError {
  order_id: string;
  booking_id: number;
  error: string;
}
export interface DelhiveryReconcileResult {
  scanned: number;
  reconciled_delivered: DelhiveryReconcileTransition[];
  reconciled_cancelled: DelhiveryReconcileTransition[];
  advanced: DelhiveryReconcileTransition[];
  unchanged: number;
  errors: DelhiveryReconcileError[];
}

export const delhiveryReconcileActive = async (
  limit = 500
): Promise<DelhiveryResult<DelhiveryReconcileResult>> => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-reconcile-active/`,
      { limit },
      { timeout: 120000 } // the call makes one Track per booking — generous client timeout
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// Dispatch-due worklist — POs committed to dispatch on/before `dispatch_date` (default today) from
// the MD warehouses, with a live Delhivery serviceability check. Read-only: it books nothing. Slow
// (one quote per PO) — long client timeout. We use it to seed the bulk-book modal with today's POs.
// The row's open logistics escalation (the board's "raise delivery escalation"), when flagged.
export interface DelhiveryEscalation {
  issue_type: string | null;
  category: string | null;
  remarks: string | null;
  raised_at: string | null; // ISO
  raised_by: string | null;
  count: number;
}
// Express vs regular dispatch mode.
export type DelhiveryMode = "express" | "regular";
export interface DelhiveryDispatchDueRow {
  po_number: string;
  mode: DelhiveryMode; // express / regular — shown as a tag next to the PO
  warehouse_id: number | null;
  warehouse_name: string | null;
  leg_status: string | null;
  leg_commited_dispatch_time: string | null; // ISO; earlier than today = overdue
  leg_commited_delivery_time: string | null; // ISO; committed customer-delivery SLA (the promise)
  delivery_planned_eta: string | null; // ISO; system/courier-planned delivery ETA
  delivery_id: number | null;
  has_escalation?: boolean; // true when this PO has an open logistics escalation
  escalation?: DelhiveryEscalation | null; // details, present only when has_escalation
  booking_id?: number | null; // present when consolidated
  consolidated_pos?: string[]; // other POs riding the same truck
  bookable?: boolean;
  error?: string; // ineligible rows only — genuinely-unbookable reason (not serviceable / no vehicle fits)
  [k: string]: any; // vehicle_mode / fare / vehicles / items / weights, passed through to the modal
}
export interface DelhiveryDispatchDueResponse {
  // Two explicit windows (YYYY-MM-DD). Dispatch = trailing week ending at the cutoff; delivery =
  // the delivery window actually applied (reflects what you queried).
  dispatch_date_from: string;
  dispatch_date_to: string;
  delivery_date_from: string;
  delivery_date_to: string;
  warehouse_ids: number[];
  mode: DelhiveryMode | null; // the applied mode filter (null = both) — reflects the active toggle
  candidate_count: number;
  quoted_count: number;
  eligible_count: number;
  ineligible_count: number;
  excluded_already_booked: number; // POs dropped because a carrier is already booked — hidden from both lists
  escalated_count: number; // how many returned rows carry an open escalation
  truncated: boolean;
  deferred_po_numbers: string[];
  eligible: DelhiveryDispatchDueRow[];
  ineligible: DelhiveryDispatchDueRow[]; // now only genuinely-unbookable POs (carries rejection_reason)
}
export interface DelhiveryDispatchDueParams {
  dispatch_date?: string; // YYYY-MM-DD; default today — the dispatch-window cutoff
  // Delivery filter (all optional, YYYY-MM-DD): a single day, or an explicit inclusive range. Omit
  // all → delivery defaults to the same trailing week as dispatch.
  delivery_date?: string;
  delivery_date_from?: string;
  delivery_date_to?: string;
  mode?: DelhiveryMode; // express / regular; omit → both (any other value 400s)
  warehouse_ids?: string; // CSV e.g. "578,721"; default both
  max_quotes?: number; // default 50, hard max 200
}
export const getDelhiveryDispatchDue = async (
  params: DelhiveryDispatchDueParams = {}
): Promise<DelhiveryDispatchDueResponse | undefined> => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/delhivery-dispatch-due/`,
      { params, timeout: 120000 } // runs live carrier quotes — generous client timeout
    );
    return res?.data as DelhiveryDispatchDueResponse;
  } catch (error: any) {
    errorActions(error, "Error loading dispatch-due POs. Please try again.");
    return undefined;
  }
};

// ============================================================================
// Delhivery BULK quote + book — for booking many POs at once from the OMS PO list.
// Bulk quote is synchronous (results inline, cap 50, one bad PO never fails the batch); bulk book is
// async/Celery (202 accepted, cap 100, already-booked/ineligible POs skipped automatically). Read
// per-PO results afterward via getDelhiveryBookings / delhiveryOrderStatus.
// ============================================================================
export interface DelhiveryBulkQuoteRow {
  po_number: string;
  bookable: boolean;
  vehicle_mode?: string;
  fare?: number;
  vehicles?: any[]; // same shape as the single quote's vehicles[]
  computed_weight_kg?: number;
  max_item_length_ft?: number;
  error?: string; // present when bookable === false
  items?: any[]; // per-PO item breakdown, present on every row (best-effort even for failed rows)
  pickup_contact_number?: string | null; // default pickup contact for this PO (prefills the box)
  drop_contact_number?: string | null; // default drop contact for this PO (prefills the box)
  pickup_contact_options?: any[]; // {label, name, value}[] — this PO's pickup contact choices
  drop_contact_options?: any[]; // {label, name, value}[] — this PO's drop contact choices
  assigned_to_name?: string | null; // ops owner — both contacts default to their number
  assigned_to_contact?: string | null;
  // Dispatch/delivery timeline — present on dispatch-due-sourced rows (ISO; shown on the card).
  leg_commited_dispatch_time?: string | null; // committed dispatch; before today = overdue
  leg_commited_delivery_time?: string | null; // committed customer-delivery SLA
  delivery_planned_eta?: string | null; // system/courier-planned delivery ETA
  // Open logistics escalation on this PO (dispatch-due-sourced) — shown as a pill on the card.
  has_escalation?: boolean;
  escalation?: DelhiveryEscalation | null;
  mode?: DelhiveryMode | null; // express / regular (dispatch-due-sourced) — shown as a tag

  // Consolidation: rows sharing one truck (one pickup+drop) are ONE Delhivery booking. Rows in the
  // same group carry the same booking_id and the same consolidated_pos set.
  consolidated?: boolean;
  consolidated_pos?: string[] | null;
  booking_id?: number;
}

export interface DelhiveryBulkQuoteResponse {
  count: number;
  results: DelhiveryBulkQuoteRow[];
}

export const delhiveryBulkQuote = async (
  po_numbers: string[],
  contacts?: { pickup_contact_number?: string; drop_contact_number?: string }
): Promise<DelhiveryBulkQuoteResponse | undefined> => {
  try {
    const body: Record<string, any> = { po_numbers };
    if (contacts?.pickup_contact_number)
      body.pickup_contact_number = contacts.pickup_contact_number;
    if (contacts?.drop_contact_number)
      body.drop_contact_number = contacts.drop_contact_number;
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-bulk-quote/`,
      body
    );
    return res?.data as DelhiveryBulkQuoteResponse;
  } catch (error: any) {
    errorActions(error, "Could not fetch the bulk Delhivery quote");
    return undefined;
  }
};

export interface DelhiveryBulkBookResponse {
  accepted: string[];
  count: number;
  note?: string;
}

// All three are optional per-PO override maps { po_number: value }, each applied only to the POs it
// lists. A PO absent from a map keeps the backend default (auto-pick vehicle, requesting-user pickup
// contact, ship-address drop contact).
export const delhiveryBulkBook = async (
  po_numbers: string[],
  options?: {
    vehicle_modes?: Record<string, string>;
    pickup_contact_numbers?: Record<string, string>;
    drop_contact_numbers?: Record<string, string>;
  }
): Promise<DelhiveryBulkBookResponse | undefined> => {
  try {
    const body: Record<string, any> = { po_numbers };
    if (options?.vehicle_modes && Object.keys(options.vehicle_modes).length > 0)
      body.vehicle_modes = options.vehicle_modes;
    if (
      options?.pickup_contact_numbers &&
      Object.keys(options.pickup_contact_numbers).length > 0
    )
      body.pickup_contact_numbers = options.pickup_contact_numbers;
    if (
      options?.drop_contact_numbers &&
      Object.keys(options.drop_contact_numbers).length > 0
    )
      body.drop_contact_numbers = options.drop_contact_numbers;
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-bulk-book/`,
      body
    );
    return res?.data as DelhiveryBulkBookResponse;
  } catch (error: any) {
    errorActions(error, "Could not bulk-book these POs with Delhivery");
    return undefined;
  }
};

// ============================================================================
// Delhivery MULTISTOP pickup — one rider collects from several vendors (multiple pickup POs) and
// drops at a single customer. Ops assembles an ordered PO list (index 0 = first pickup, rest =
// stops in route order); quote validates the set + suggests other same-customer POs to club +
// returns the vehicle/fare; book commits it as one Delhivery order.
//
// Like the single-PO helpers, these branch on HTTP status, so they return the normalized
// { ok, status, data, error } instead of throwing:
//   quote 200 → { selected, drop, suggestions, quote (null when <2 POs), quote_error }
//   quote 4xx → the selected set can't be clubbed (400 mixed drop / incomplete / no customer leg,
//               404 PO not found, 409 a PO already booked); reason in `error`.
//   book  200 → { order_id (CRN...), booking_id, vehicle_mode, fare, tracking_url, po_numbers }
//   book  4xx/5xx → validation / already-booked / Delhivery failure; reason in `error`.
// ============================================================================
// One choice in a contact dropdown (matches ContactSelect's ContactOption — {label, name, value}).
export interface MultistopContactOption {
  label: string;
  name: string | null;
  value: string;
}

// One line item on a pickup PO — same shape as the single/bulk quote's items[].
export interface MultistopItem {
  allocation_item_id: number;
  name: string;
  quantity: number;
  unit?: string | null;
  category?: string | null;
  category_id?: number | null;
  included?: boolean; // false → excluded from this shipment (greyed)
  weight_kg?: number | null;
  volume_cm3?: number | null;
  max_length_ft?: number | null;
}

export interface MultistopLeg {
  po_number: string;
  vendor: string | null;
  city: string | null;
  pincode: string | null;
  contact_number?: string | null; // current default pickup POC — prefills the row's contact dropdown
  // Pickup contact choices for this PO's dropdown. Only present on `selected` legs (not suggestions),
  // same field name/shape as bulk-quote's per-row pickup_contact_options.
  pickup_contact_options?: MultistopContactOption[];
  items?: MultistopItem[]; // this PO's line items — shown under the pickup row (selected legs only)
}

export interface MultistopDrop {
  name: string | null;
  address: string | null;
  city: string | null;
  pincode: string | null;
  lat?: number | null; // customer drop coordinates — the final point on the route map
  lng?: number | null;
  contact_number?: string | null; // current default drop POC — prefills the drop contact dropdown
  drop_contact_options?: MultistopContactOption[]; // drop contact choices (same shape as bulk-quote)
}

// Pickup coordinates for the route map, keyed by VENDOR name (a leg's coords are stops[leg.vendor]).
export type MultistopStops = Record<string, { lat: number; lng: number }>;

export interface MultistopQuote {
  vehicle_mode: string | null;
  fare: number | null; // INR; may be null if the carrier didn't return one
  weight_kg: number | null;
  max_length_ft: number | null;
  item_count: number | null;
}

// One selectable vehicle from the quote's `vehicles[]` — same shape as the single-PO quote. Fields
// beyond these vary, so it stays loose.
export interface MultistopVehicle {
  type: string;
  fare?: { currency?: string; amount?: number };
  capacity?: { value?: number; unit?: string };
  eligible?: boolean;
  priority?: number | null; // 1 = recommended
  ineligible_reason?: string | null;
  max_dimensions?: string | null; // display string only (units vary); render verbatim
  effective_weight_kg?: number | null;
}

export interface MultistopQuoteData {
  selected: MultistopLeg[];
  drop: MultistopDrop | null;
  suggestions: MultistopLeg[];
  quote: MultistopQuote | null; // null in suggest-only mode (<2 POs) or when quote_error is set
  quote_error: string | null; // clubbable but not quotable now (unserviceable / too heavy)
  apiKey?: string | null; // Google Maps JS API key for the embedded route map
  stops?: MultistopStops; // pickup coordinates keyed by vendor name (drop coords live on `drop`)
  vehicles?: MultistopVehicle[]; // selectable vehicle modes with fares (recommended = priority 1)
  route_optimized?: boolean; // true when the backend reordered the pickups → show the "optimized" hint
  assigned_to_name?: string | null; // ops owner — every pickup leg + the drop default to their number
  assigned_to_contact?: string | null;
}

// Contact overrides sent on quote/book: a per-PO pickup map (PO → 10-digit mobile) and one drop
// number. Omitting a PO keeps its default; the backend 400s a malformed number.
export interface MultistopContacts {
  pickup_contacts?: Record<string, string>;
  drop_contact_number?: string;
}

// Book is async (202 Accepted): it enqueues the consolidated booking and returns immediately — the
// CRN/tracking are NOT here. Poll GET /delhivery-bookings/ (filtered by these POs) for the result.
export interface MultistopBookAccepted {
  accepted: string[];
  count: number;
  note?: string;
}

// Add the optional per-PO pickup contacts + drop number to a request body (only when non-empty).
const applyContacts = (
  body: Record<string, any>,
  contacts?: MultistopContacts
): Record<string, any> => {
  if (contacts?.pickup_contacts && Object.keys(contacts.pickup_contacts).length > 0)
    body.pickup_contacts = contacts.pickup_contacts;
  if (contacts?.drop_contact_number) body.drop_contact_number = contacts.drop_contact_number;
  return body;
};

// Quote & suggest. Send the ordered list (index 0 = first pickup) as { po_numbers }; a single PO may
// be sent as { po_number } to fetch suggestions only. Optional contacts (pickup map + drop number)
// prefill/override the POCs. Call on open and after every add/remove/reorder/contact-edit
// (debounce ~400ms in the caller).
export const delhiveryMultistopQuote = async (
  po_numbers: string[],
  contacts?: MultistopContacts
): Promise<DelhiveryResult<MultistopQuoteData>> => {
  try {
    // One PO → suggest-only mode uses the singular key; 2+ → the ordered list.
    const body: Record<string, any> =
      po_numbers.length === 1 ? { po_number: po_numbers[0] } : { po_numbers };
    applyContacts(body, contacts);
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-multistop-quote/`,
      body
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

// Book. Send the final ordered list ({ po_numbers }, min 2, index 0 = pickup). `vehicle_mode` is the
// mode the user picked from the quote's vehicles[] — omit to let the backend fall back to its
// priority-1 default. Contacts are sent through so the rider's pickup/drop POCs reflect any override.
// Async: 202 → { accepted, count, note } (poll /delhivery-bookings/ for the CRN); 400 → bad input.
export const delhiveryMultistopBook = async (
  po_numbers: string[],
  opts: { vehicle_mode?: string; pickup_otp_enabled?: boolean; drop_otp_enabled?: boolean } & MultistopContacts = {}
): Promise<DelhiveryResult<MultistopBookAccepted>> => {
  try {
    const payload: Record<string, any> = { po_numbers };
    if (opts.vehicle_mode) payload.vehicle_mode = opts.vehicle_mode;
    // Per-handover OTP flags — each always sent as a real boolean (default false). "pickup" applies
    // to the first pickup; "drop" applies to the final customer drop + every vendor stop. (Replaces
    // the old otp_enabled.)
    payload.pickup_otp_enabled = opts.pickup_otp_enabled === true;
    payload.drop_otp_enabled = opts.drop_otp_enabled === true;
    applyContacts(payload, opts);
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-multistop-book/`,
      payload
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

export interface MultistopCancelData {
  order_id: string | null;
  booking_id: number | null;
  status: string; // "cancelled" | "cancellation_requested"
  lifecycle?: string;
  po_numbers?: string[];
}

// Cancel the whole trip. Keyed by order_id (or booking_id). Only allowed before the first pickup is
// collected — once collection starts the backend 409s ("use reattempt delivery instead"); surface it
// and hide the Cancel button.
export const delhiveryMultistopCancel = async (id: {
  order_id?: string;
  booking_id?: number;
}): Promise<DelhiveryResult<MultistopCancelData>> => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-multistop-cancel/`,
      id
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};

export interface MultistopDetachData {
  order_id: string; // unchanged — the CRN keeps running
  booking_id: number;
  detached_po: string;
  remaining_po_numbers: string[];
  rebookable: boolean;
}

// Decouple ONE PO from a live multistop trip — DB-only, nothing sent to Delhivery. The rider still
// services the other pickups; the freed PO becomes rebookable. 409 when that PO was already collected
// (reattempt instead) or it's the last PO on the trip (cancel the trip instead) — surface the message.
export const delhiveryMultistopDetach = async (
  po_number: string
): Promise<DelhiveryResult<MultistopDetachData>> => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/delhivery-multistop-detach/`,
      { po_number }
    );
    return { ok: true, status: res.status, data: res?.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 0,
      data: error?.response?.data ?? null,
      error: delhiveryError(error),
    };
  }
};
